import styled from '@emotion/styled'
import Cookie from 'js-cookie'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Index() {
  const [head, setheader] = useState('')
  const [username, setusername] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const head = localStorage.getItem('head') || 'https://imgvip.meishubao.com/teacher/img/default_avatar.jpg'
    const username = localStorage.getItem('username') || 'default_user_name'
    const uid = localStorage.getItem('userid')
    if (uid) {
      setheader(head)
      setusername(username)
    }
  }, [])

  const logout = () => {
    localStorage.removeItem('head')
    localStorage.removeItem('username')
    localStorage.removeItem('userid')
    localStorage.removeItem('token')
    Cookie.remove('token')
    window.location.replace('/')
  }

  return (
    <Container>
      <span id="head_userName" className="username">
        {username}
      </span>
      <img id="head_avatar" className="head-avatar" alt="" src={head} />
      <div className="context-menu" id="context_menu">
        <ul>
          {/* <li onClick={this.toCenter.bind(this)}>
                            个人中心
                        </li> */}
          <li id="btn_logout" onClick={logout}>
            退出登录
          </li>
        </ul>
      </div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
    cursor: pointer;
    padding: 6px 0;
    box-sizing: border-box;
    position: relative;
    .username {
      line-height: 40px;
      font-size: 14px;
      display: block;
      font-weight: 300;
      margin-right: 8px;
    }

    .head-avatar {
      height: 44px;
      width: 44px;
      border-radius: 44px;
    }

    .context-menu {
      display: none;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 0px 0px 4px 4px;
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      width: 150px;
      text-align: center;
      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
        user-select: none;
        li {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(77, 77, 77, 1);
          line-height: 27px;
          padding: 5px 15px;
          &:hover {
            background: rgba(245, 245, 245, 1);
            box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.05);
            border-radius: 0px 0px 4px 4px;
            color:black
          }
        }
      }
    }

    &:hover {
      .context-menu {
        display: block;
      }
    }
  }
`
